module.exports = "/_next/static/images/16ffb6af3aa469f7bb5d1d7f21485eeb-credit-card-perks-lg-1x.png";